<template>
        <Ebusy :link="urls[$route.params.id]"
               :key="$route.params.id"></Ebusy>
</template>
<script>
    import Ebusy from "../components/Ebusy";

    export default {
        components: {Ebusy},
        data() {
            return {
                urls: {
                    aussenplaetze: "https://etc-ellerau-v8.ebusy.de/embed/lite-module/191",
                    halle: "https://etc-ellerau-v8.ebusy.de/embed/court-module/14"
                }
            }
        },
            mounted() {
                this.$store.commit('SET_TITLE', 'Buchungen')
            }
    }
</script>
<style scoped>
        .fullscreen {
                padding:0;
                margin:0;
        }
</style>
